import { DateTime } from 'luxon';

/**
 * Format a Firestore timestamp to a readable date string
 * @param {Object} timestamp - Firestore timestamp object
 * @param {string} format - Optional format string (defaults to 'DATE_FULL')
 * @returns {string} Formatted date string
 */
export const formatDate = (timestamp, format = DateTime.DATE_FULL) => {
  if (!timestamp) return 'Unknown date';
  
  // Convert Firestore timestamp to JavaScript Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  
  // Use Luxon to format the date
  return DateTime.fromJSDate(date).toLocaleString(format);
};

/**
 * Format a Firestore timestamp to a readable date and time string
 * @param {Object} timestamp - Firestore timestamp object
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp) return 'Unknown date';
  
  // Convert Firestore timestamp to JavaScript Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  
  // Use Luxon to format the date and time
  return DateTime.fromJSDate(date).toLocaleString(DateTime.DATETIME_FULL);
};

/**
 * Format a Firestore timestamp with time and timezone
 * @param {Object} timestamp - Firestore timestamp object
 * @param {string} timeString - Time string in HH:MM format
 * @param {string} timezone - IANA timezone string
 * @returns {string} Formatted date and time string
 */
export const formatEventDateTime = (timestamp) => {
  if (!timestamp) return 'Unknown date';
  
  // Format the date and time
  return formatDateTime(timestamp);
};


/**
 * Get a short formatted date for previews
 * @param {Object} timestamp - Firestore timestamp object
 * @returns {string} Short formatted date
 */
export const formatShortDate = (timestamp) => {
  if (!timestamp) return 'Unknown date';
  
  // Convert Firestore timestamp to JavaScript Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  
  // Use Luxon to format the date
  return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_MED);
};

/**
 * Get a short formatted date and time for previews
 * @param {Object} timestamp - Firestore timestamp object
 * @returns {string} Short formatted date and time
 */
export const formatShortDateTime = (timestamp) => {
  if (!timestamp) return 'Unknown date';
  
  // Convert Firestore timestamp to JavaScript Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  
  // Use Luxon to format the date and time
  return DateTime.fromJSDate(date).toLocaleString(DateTime.DATETIME_SHORT);
};